const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速播放不缓冲',
    desc: '智能CDN加速与多线路自动切换技术，确保在任何网络环境下都能获得流畅无卡顿的高清播放体验，告别缓冲等待。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净免费无广告干扰',
    desc: '坚持免费在线观看的核心理念，无需注册登录，无需付费会员。清爽的界面设计让你专注追剧本身，享受纯粹的观影时光。',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时同步最快更新',
    desc: '与各大内容源保持分钟级同步，热门剧集播出后最快2小时内上线。每日更新量超50部，确保追剧进度永不落后。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么超过百万追剧人选择努努影院
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[960px] mx-auto">
          {features.map((feat, index) => (
            <div
              key={index}
              className="text-center bg-background-100 border border-background-200 rounded-2xl p-6 md:p-8 transition-all duration-300 hover:shadow-md"
            >
              <span className="w-14 h-14 flex items-center justify-center bg-primary-100 text-primary-500 rounded-2xl mx-auto mb-4 text-2xl">
                <i className={feat.icon}></i>
              </span>
              <h3 className="text-base font-bold text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}